import { createMemo, Show } from "solid-js";
import theme from "theme";

interface EntityBackgroundProps {
  poster?: string;
  backdrop?: string;
}

export default function EntityBackground(props: EntityBackgroundProps) {
  const bgImage = createMemo(() => {
    return props.backdrop || props.poster;
  });

  return (
    <view x={0} y={0} width={theme.layout.screenW} height={1080} zIndex={100}>
      <Show when={bgImage()}>
        <view
          src={bgImage() || ""}
          width={theme.layout.screenW}
          height={1080}
          x={0}
          y={0}
          onFail={(node) => (node.src = "./assets/fallback.png")}
        />
      </Show>

      {/* Dark overlay with horizontal gradient for hero text readability */}
      <view
        width={theme.layout.screenW}
        height={1080}
        colorLeft={0x080808ff}
        colorRight={0x08080800}
      />

      {/* Dark overlay with vertical gradient for the episodes row at the bottom */}
      <view
        y={400}
        width={theme.layout.screenW}
        height={680}
        colorTop={0x08080800}
        colorBottom={0x080808ff}
      />
    </view>
  );
}
